import React from 'react'
import TechnicalServicePage from '../components/TechnicalServicePage'

const MicrobiomePage = () => {
  return <TechnicalServicePage serviceKey="microbiome" />
}

export default MicrobiomePage
